import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex cursor-pointer items-center gap-2',
    text: 'heading-m font-semibold',
    icon: ''
  },
  variants: {
    view: {
      default: {
        base: 'gap-2 lg:w-150'
      },
      compact: {
        base: 'gap-1',
        icon: 'size-[18px]'
      }
    }
  },
  defaultVariants: {
    view: 'default'
  }
});
